import { render, staticRenderFns } from "./ClaimFormTab.vue?vue&type=template&id=3e202e14&scoped=true"
import script from "./ClaimFormTab.vue?vue&type=script&lang=js"
export * from "./ClaimFormTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e202e14",
  null
  
)

export default component.exports